import css from 'styled-jsx/css';

const styles = css.global`#disclaimer-f1 {
    padding-top: 16px;
}

#disclaimer-f1 .disclaimer-f1-text {
    margin: 0;
    color: #444;
    font-family: "SantanderMicroText";
    font-size: 12px;
    line-height: 18px;
    text-align: center;
}

#disclaimer-f1 .disclaimer-f1-text a {
    color: #e60000;
    text-decoration: underline;
}`;

export default styles;